import { ApiState } from '../../utils/requestAction';
import requestReducer from '../requestReducer';


export interface ProductSubgroupUpsertState extends ApiState {
  productSubgroupId?: string
}

export default requestReducer<ProductSubgroupUpsertState>('PRODUCTSUBGROUP_UPSERT')
